import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import acl from "./acl.js";
import "@/assets/sass/main.scss";
import "./assets/sass/notifications.scss";
import Notifications from "vue-notification";
Vue.config.productionTip = false;

Vue.use(VueSweetalert2);
Vue.use(Notifications);
import "sweetalert2/dist/sweetalert2.min.css";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);

Vue.directive(acl);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
